import { CaretDown } from '@phosphor-icons/react'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@radix-ui/react-accordion'
import clsx from 'clsx'
import { JSX, useState } from 'react'
import Content from '../elements/Content'
import { BardAccordion as BardAccordionType } from '@/src/@types/statamic'
import trackEvent from '@/src/lib/tracking'

export default function BardAccordion({
  accordion,
  fullWidth,
}: BardAccordionType & { fullWidth?: boolean }) {
  const [value, setValue] = useState<string[]>([])

  const sendGTMEvent = (title: string) => {
    // value isn't updated yet
    if (!value.includes(title)) {
      trackEvent({
        event: 'accordion_open',
        params: {
          title,
        },
      })
    }
  }

  return (
    <Accordion
      type="multiple"
      value={value}
      onValueChange={setValue}
      className={clsx([
        'max-w-full md:text-xl',
        {
          'lg:max-w-[66%]': !fullWidth,
        },
      ])}
    >
      {accordion.map((item, index) => {
        const HeadingComponent: keyof Pick<
          JSX.IntrinsicElements,
          'h2' | 'h3' | 'h4'
        > = item.title_tag.value

        return (
          <div
            key={index}
            className={clsx([
              'border-t border-gray-150',
              {
                'border-b': index === accordion.length - 1,
              },
            ])}
          >
            <AccordionItem value={item.title}>
              <HeadingComponent>
                <AccordionTrigger
                  onClick={() => sendGTMEvent(item.title)}
                  className="group flex w-full cursor-pointer items-center justify-between py-4"
                >
                  <span className="text-left font-bold md:text-xl">
                    {item.title}
                  </span>
                  <CaretDown
                    size={24}
                    weight="bold"
                    className="shrink-0 text-gray-600 transition duration-150 group-data-[state=open]:rotate-180"
                  />
                </AccordionTrigger>
              </HeadingComponent>
              <AccordionContent className="overflow-hidden pb-3 transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
                <Content content={item.text} />
              </AccordionContent>
              <Content content={item.text} className="hidden" />
            </AccordionItem>
          </div>
        )
      })}
    </Accordion>
  )
}
